import { TYPE_HUES } from '../Forms/Roadblock/constants';

// Chart color derived from the shared bisection palette.
// Types 1–14 get vivid colours (75% sat, 48% lightness).
// Types 15–28 reuse the same hues at a lighter shade (55% lightness)
// so the second cycle is visually distinct from the first.
export const typeChartColor = (typeId) => {
    const id     = typeId ?? 0;
    const hue    = TYPE_HUES[id % TYPE_HUES.length];
    const round  = Math.floor(id / TYPE_HUES.length) % 2; // 0 = vivid, 1 = light
    return round === 0
        ? `hsl(${hue}, 75%, 48%)`
        : `hsl(${hue}, 55%, 68%)`;
};

// The states this application operates in.
// Names are resolved at runtime via country-state-city.
export const OPERATING_STATE_CODES = ['ID', 'MT', 'OR', 'UT', 'WA', 'WI'];
